import Vue from "vue"
import { Settings, DateTime, Duration, Interval, Info } from "luxon"

Settings.defaultLocale = "sv"

Object.defineProperty(Vue.prototype, "$DateTime", { value: DateTime })
Object.defineProperty(Vue.prototype, "$Duration", { value: Duration })
Object.defineProperty(Vue.prototype, "$Interval", { value: Interval })
Object.defineProperty(Vue.prototype, "$Info", { value: Info })